<template>
  <div
    v-if="comps.length > 0"
    id="xy-client-layout-nav-comps"
  >
    <template v-for="(c, cIndex) of comps">
      <NavCompsUcRenderer
        v-if="isPageletComponent(c)"
        :key="cIndex"
        :comp="c"
        :mode="mode"
      />
      <NavCompsRender
        v-else-if="loadedComponents.includes(c.name)"
        ref="comps"
        :key="cIndex"
        :comp="c"
        :mode="mode"
      />
    </template>
  </div>
</template>

<script>
import { getCompsList } from '@/utils/comps-loader';
import NavCompsRender from './NavCompsRender';
import NavCompsUcRenderer from './NavCompsUcRenderer';

export default {
  name: 'NavComps',
  components: {
    NavCompsRender,
    NavCompsUcRenderer,
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
    position: {
      type: String,
      default: 'right',
    },
    mode: {
      type: String,
      default: 'runtime',
    },
  },
  data() {
    return {
      isComponentLoaded: false,
      loadedComponents: [],
    };
  },
  computed: {
    compsKey() {
      return [...new Set(this.comps.map(c => c.name))].join(';');
    },
    comps() {
      const dynamicComps = this.project?.uiInfo?.navlink?.dynamicComps ?? [];
      return dynamicComps.filter(c => c.isShow && this.matchPosition(c) && this.matchPage(c));
    },
  },
  watch: {
    comps: {
      async handler(comps) {
        const keys = comps.map(c => c.name).filter(name => !this.loadedComponents.includes(name));
        this.loadNecessaryComponents(keys);
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    async loadNecessaryComponents(keys) {
      if (Array.isArray(keys) && keys.length > 0) {
        await getCompsList({
          compsKey: keys,
          register: true,
        });
        this.loadedComponents.push(...keys);
      }
    },
    isPageletComponent(comp) {
      const { name } = comp;
      const module = window.wujiComp.moduleManage.installedModules[name];
      if (!module) {
        return false;
      }
      return module.compDB?.extraInfo?.type === 'pagelet';
    },
    // 根据组件的展示位置过滤
    matchPosition(comp) {
      return (comp.position || 'right') === this.position;
    },

    // 根据页面过滤
    matchPage(comp) {
      const currentPageId = this.$route?.meta?.pageId;
      const { pages } = comp;
      let { visible } = comp;
      if (!visible) visible = pages?.length ? 'include' : 'exclude';
      if (visible === 'all') return true; // 所有
      if (visible === 'exclude') return !pages?.includes(currentPageId); // 隐藏
      return pages?.includes(currentPageId); // 显示
    },
  },
};
</script>

<style lang="scss" scoped>
#xy-client-layout-nav-comps {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
